var DialogArchiveOrUnarchiveUserModule = /** @class */ (function () {
    function DialogArchiveOrUnarchiveUserModule() {
    }
    return DialogArchiveOrUnarchiveUserModule;
}());
export { DialogArchiveOrUnarchiveUserModule };
